<template>
  <h1 :id="data.url" class="cm-documentation__content-title">{{ data.content }}</h1>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.cm-documentation__content-title {
  margin: 1.5rem 0 !important;
  font-size: $font-size_large;
  line-height: 1.5;
  font-weight: $font-weight_sans_ui_bold;
  letter-spacing: normal;
}
</style>
